<template>
    <div>
        <div class="row mb-3">
            <div class="col-md-12">
                <h1>
                    <i class="fas fa-cogs text-primary"></i> {{$t('part.title')}}
                </h1>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <div class="h5 mb-4">
                    <a
                        href
                        class="badge badge-primary text-white mr-1"
                        @click.prevent="setCatId('')"
                    >All</a>
                    <a
                        href
                        v-for="(cat, i) in categories"
                        class="badge badge-primary text-white mr-1"
                        @click.prevent="setCatId(cat.id)"
                    >{{$t('part.categories.' + cat.name.toLowerCase())}}</a>
                </div>
                <div class="row">
                    <ItemRepairStatus v-for="item in forSale" :key="item.id" :product="item"/>
                </div>
            </div>
            <div v-if="showCart" class="col" style="max-width:400px;min-width:300px;">
                <ShoppingCart :cart_title="$t('request.partsrequest')" :showButtons="true" :showRequestButton="requestButton"/>
            </div>
        </div>
    </div>
</template>

<script>
import ItemRepairStatus from "./ItemRepairStatus.vue";
import ShoppingCart from "./ShoppingCart.vue";
import uniqBy from "lodash/uniqBy";

export default {
  name: "Parts",
  props: {
    showCart: {
      type: Boolean,
      default: true
    },
    showReqButton: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      catId: ""
    };
  },
  computed: {
    requestButton() {
      return this.showReqButton;
    },
    forSale() {
      if (!this.catId) return this.all;
      return this.all.filter(item => {
        return item.categories
          .map(o => o["id"])
          .join(", ")
          .includes(this.catId);
      });
    },
    all() {
      return this.$store.getters["cart/all"];
    },
    categories() {
      return this.$store.getters["cart/categories"];
    }
  },
  methods: {
    setCatId(catId) {
      this.catId = catId;
    }
  },
  components: {
    ItemRepairStatus,
    ShoppingCart
  }
};
</script>
